import supabase from "./Supabase";

type Script = {
    file_id: string;
    Title: string;
    "Script Title": string;
    "Writer(s)": string;
    "Draft Date": string | null;
    "Additional Info": string | null;
    additional_info_concat: string;
    "Date Added": string;
    "Document Type": string | null;
    Draft: string | null;
    storage_hash: string;
    google_drive_hash: string | null;
    tags: string[];
    script_tags?: { tags: { tag_id: number; name: string } }[];
    indexing?: {
        index_user_id: string;
        userData?: {
            email?: string;
        };
    };
};


export async function getScripts(
    table = "files",
    fields = `
        file_id,
        "Title",
        "Script Title",
        "Writer(s)",
        "Draft Date",
        "Additional Info",
        additional_info_concat,
        "Date Added",
        "Document Type",
        Draft,
        storage_hash,
        google_drive_hash,
        script_tags(tags(tag_id, name)),
        indexing (
            index_user_id,
            userData (
                email
            )
        )
        `,

    order = "last_updated"
) {
    const { data, error } = await supabase
        .from(table)
        .select(fields)
        .eq("record_deleted", false)
        .order(order, { ascending: false });

    if (error) {
        console.error("Supabase error:", error);
        return [];
    }

    const sortedData = data.sort((a, b) => {
        const aDate = new Date(a["Date Added"]);
        const bDate = new Date(b["Date Added"]);
        return aDate === bDate ? 0 : aDate < bDate ? 1 : -1;
    });

    if (!data || !Array.isArray(data)) return [];

    const reformattedData = (data as unknown as Script[]).map((script) => ({
        ...script,
        tags: (script.script_tags || []).map(st => st.tags?.name).filter(Boolean) as string[],
        "Indexed By": script.indexing?.userData?.email ?? undefined
    }));

    return reformattedData;
}
